import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=cc56964c&scoped=true&"
import script from "./confirmDialog.vue?vue&type=script&lang=js&"
export * from "./confirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=cc56964c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc56964c",
  null
  
)

export default component.exports